var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box p-4 has-background-white mb-0" }, [
    _c("nav", { staticClass: "level is-mobile" }, [
      _c("div", { staticClass: "level-left" }, [
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-primary",
              on: {
                click: function ($event) {
                  return _vm.$emit("download")
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-download" }),
              _vm._v(
                " Descargar " + _vm._s(this.getTipoOtroDocumento) + "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-light is-hidden-touch",
              on: {
                click: function ($event) {
                  return _vm.$emit("preview")
                },
              },
            },
            [_c("i", { staticClass: "fas fa-glasses fa-fw" }), _vm._v(" Ver")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-light is-hidden-touch",
              on: {
                click: function ($event) {
                  return _vm.$emit("print")
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-print fa-fw" }),
              _vm._v(" Imprimir"),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-light",
              on: {
                click: function ($event) {
                  return _vm.$emit("refresh")
                },
              },
            },
            [_c("i", { staticClass: "fas fa-sync fa-fw" }), _vm._v(" Recargar")]
          ),
        ]),
      ]),
      _vm._v(" "),
      this.hasAdminOrLyrisRole
        ? _c("div", { staticClass: "level-right" }, [
            _c(
              "div",
              { staticClass: "level-item" },
              [
                _c(
                  "b-dropdown",
                  {
                    attrs: { "aria-role": "list", position: "is-bottom-left" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "trigger",
                          fn: function ({ active }) {
                            return _c(
                              "button",
                              { staticClass: "button is-light" },
                              [
                                _vm._v("\n            Otras acciones "),
                                _c("i", {
                                  staticClass: "fas fa-fw",
                                  class: active
                                    ? "fa-chevron-up"
                                    : "fa-chevron-down",
                                }),
                              ]
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      2568661532
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { "aria-role": "listitem" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("preview")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-glasses fa-fw" }),
                        _vm._v(" Ver"),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      {
                        staticClass: "has-text-danger",
                        attrs: { "aria-role": "listitem" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("deleteDocument")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-trash fa-fw" }),
                        _vm._v(" Eliminar"),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }